// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5235":"d2bad2610927b606","5748":"d02f5d03040184eb"}[chunkId] + ".js";
};